import { render, staticRenderFns } from "./RoleSelector.vue?vue&type=template&id=05c857cf"
import script from "./RoleSelector.vue?vue&type=script&lang=js"
export * from "./RoleSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports